export default __webpack_public_path__ + "static/media/as.e855dcb3.svg";